<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);">
            <i class="fa fa-id-badge text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Funcionários</h4>
            <p class="text-muted mb-0 small">Gerenciamento e consulta de colaboradores</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input type="text" ref="edDescricao" v-model="nome" placeholder="Buscar por nome..." class="border-0 bg-transparent" style="width: 250px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Novo Funcionário</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Código</label>
                      <b-form-input type="text" v-model="id" placeholder="ID" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    ref="tbl"
                    class="mb-0 table-finance"
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    show-empty
                    empty-text="Nenhum funcionário encontrado"
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    @row-clicked="clicarLinha"
                    :per-page="perPage"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
                  
              <!-- Cabeçalho: ID -->
              <template #head(CODIGO)>
                <SetFilter
                  label="ID"
                  v-model="filtros.CODIGO"
                  :options="opcoes.CODIGO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(NOME)>
                <SetFilter
                  label="Nome"
                  v-model="filtros.NOME"
                  :options="opcoes.NOME"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(CARGO)>
                <SetFilter
                  label="Cargo"
                  v-model="filtros.CARGO"
                  :options="opcoes.CARGO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(TELEFONE)>
                <SetFilter
                  label="Telefone"
                  v-model="filtros.TELEFONE"
                  :options="opcoes.TELEFONE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(OP_SITUACAO)>
                <SetFilter
                  label="Situação"
                  v-model="filtros.OP_SITUACAO"
                  :options="opcoes.OP_SITUACAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>
              <template #cell(OP_SITUACAO)="item">
                <b-badge pill :variant="colorirSITUACAO(item.item.OP_SITUACAO)" class="px-3 py-1 shadow-xs" >{{traduzirSITUACAO(item.item.OP_SITUACAO)}} </b-badge>
              </template>
              <template #cell(TELEFONE)="item">
                {{formatarTelefone(item.item.TELEFONE)}}
              </template>
              
              <!-- Rodapé com contagem de registros -->
              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td :colspan="fields.length" class="bg-light font-weight-bold text-dark border-top">
                    Total de Registros: {{ itensFiltrados.length }}
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
      
      <!-- Modal de Confirmação para Resultado Grande -->
      <ModalAlertaResultadoGrande
        ref="modalConfirmacao"
        :count="resultadoPendenteCount"
        @confirmar="confirmarCarregarResultadoGrande"
        @cancelar="cancelarCarregarResultadoGrande"
        @shown="onModalShown"
        @hidden="onModalHidden"
      />
      
    </div>  
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'


export default {
  components: {
    SetFilter,
    ModalAlertaResultadoGrande
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    minSticky: 500,
    preferVh: 70,
    filters: [
      { key: 'CODIGO', type: 'number', label: 'ID' },
      { key: 'NOME', type: 'string', label: 'Nome' },
      { key: 'CARGO', type: 'string', label: 'Cargo' },
      { key: 'TELEFONE', type: 'string', label: 'Telefone'},
      { key: 'OP_SITUACAO',   type: 'string', label: 'Situação',
              labelMap: { '1': 'Ativo', '0': 'Inativo', null:'Inativo'} }
    ]
  })],

  data () {
    return {
      isLoading: false,
      status: '',
      isBusy: false,
      colunas: [
        { key: "CODIGO",      label: 'ID', sortable: true, class:'align-middle text-right', thStyle: { width: "10%" }},
        { key: "NOME", label: 'Nome', sortable: true, class:'align-middle', thStyle: { width: "40%" }},
        { key: "CARGO", label: 'Cargo', sortable: true, class:'align-middle', thStyle: { width: "25%" }},
        { key: "TELEFONE", label: 'Teleone', sortable: true, class:'align-middle text-right', thStyle: { width: "10%" }},
        { key: "OP_SITUACAO", label: 'Status', sortable: true, class:'align-middle text-center', thStyle: { width: "10%" }},
        { key: "actions", label: 'Ações', class:'align-middle text-center p-0 ', thStyle: { width: "5%" }, sortable: false }
      ],
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
    }
  },
  
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },

    // Cada tabela constrói sua própria rowFilter a partir da sua config
    rowFilterListagem() { 
      return this.buildRowFilter(this.filtrosConfig) 
    },
    currentPage: {
      get () {
        return this.$store.getters['funcionario/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("funcionario/SET_PAGINA_ATUAL", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['funcionario/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("funcionario/SET_FILTRO_AVANCADO", value);
      }
    },
    filtroCabecalho: {
      get () {
        return this.$store.getters['funcionario/FILTRO_CABECALHO']
      }, 
      set (value) {
        this.$store.commit("funcionario/SET_FILTRO_CABECALHO", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['funcionario/ID']
      }, 
      set (value) {
        this.$store.commit("funcionario/SET_ID", value);
      }
    },
    nome: {
      get () {
        return this.$store.getters['funcionario/NOME']
      }, 
      set (value) {
        this.$store.commit("funcionario/SET_NOME", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['funcionario/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('funcionario/SET_PER_PAGE', Number(v) || 25)
      }
    },
    lista: {
      get () {
        return this.$store.getters['funcionario/LISTA']
      }, 
      set (value) {
        this.$store.commit("funcionario/SET_LISTA", value);
      }
    },/*
    lista() {
      return this.$store.getters['funcionario/LISTA']
    }*/
  },
  methods: {

    
    limparFiltros() {
      this.teste.filtros = { nome: '', cidade: '', status: '' }
    },
    formatarTelefone(texto) {
      return Tools.formatarTelefone(texto)
    },
    clicarLinha(item) {
      this.$store.commit("funcionario/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['funcionario/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    colorirSITUACAO(item) { 
      return item === '1' ? 'success' : 'danger'
    },

    traduzirSITUACAO(item) { 
      return item === '1' ? 'ATIVO' : 'INATIVO'
    },
    traduzirTIPO(item) { 
      return item === 'I' ? 'INTERNO' : 'EXTERNO'
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    limparFiltro() {
      this.$store.commit("funcionario/SET_LIMPAR", null);
    },
    edit (item) {
      this.$store.commit("funcionario/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
      this.$router.push(`/cadastros/funcionario/edit/${item.CODIGO}`)
    },
    novo () {
      this.$router.push(`/cadastros/funcionario/add`)
    },
    async pesquisar () {
      // Impede pesquisa se o modal está aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      try {
        // Remove o foco do input antes de abrir modal
        const inputElement = this.$refs.edDescricao
        if (inputElement && inputElement.$el) {
          inputElement.$el.blur()
        } else if (inputElement) {
          inputElement.blur()
        }
        
        const result = await this.$store.dispatch('funcionario/GET_LISTA')
        
        // Verifica se precisa de confirmação
        if (result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmacao.show()
          return
        }

        this.scrollToSelected()
        
      } catch(err) {
        this.lista = []
        this.$store.commit('controle/setAguardando', false)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível consultar os dados solicitados' )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    confirmarCarregarResultadoGrande() {
      // Fecha o modal
      this.$refs.modalConfirmacao.hide()
      
      // Carrega os dados pendentes
      if (this.resultadoPendente) {
        this.$store.commit('funcionario/SET_LISTA', this.resultadoPendente)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
        this.scrollToSelected()
      }
    },
    cancelarCarregarResultadoGrande() {
      // Apenas fecha o modal e limpa os dados pendentes
      this.$refs.modalConfirmacao.hide()
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 300)
      })
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Funcionários',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.colunas.filter(f => f.key !== 'actions'),
        filename: 'funcionarios.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions'),
        filename: 'funcionarios.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions'),
        filename: 'funcionarios.csv',
      });
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      } 
    }
  },
  async created() {
    await this.pesquisar()
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    this.$nextTick(() => {
      this.$refs.edDescricao?.focus()
      this.scrollToSelected()
    })
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>
<style >
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky */
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #adbac3 !important;
}

/* Estilos Premium */
.table-finance thead th {
  background-color: #f8f9fa;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 8px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 4px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.custom-input-premium {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0.6rem 1rem;
  transition: all 0.2s;
}

.custom-input-premium:focus {
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}

</style>



// WEBPACK FOOTER //
// src/views/cadastros/funcionario/FuncionarioListagem.vue